import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerByEmail } from "../../store/actions/userActions";
import { selectCustomer, selectError, selectLoading } from "../../store/reducers/userSlice";

export const useUser = () => {
  const dispatch = useDispatch();
  const customer = useSelector(selectCustomer);
  const loading = useSelector(selectLoading);
  const error = useSelector(selectError);

  const fetchCustomer = async (email, customerId) => {
    return await dispatch(fetchCustomerByEmail({ email, customerId }));
  };

  return {
    fetchCustomer,
    customer,
    loading,
    error,
  };
};
